import { render, staticRenderFns } from "./lid-client-staff.vue?vue&type=template&id=6f228c44&"
import script from "./lid-client-staff.vue?vue&type=script&lang=js&"
export * from "./lid-client-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports